import React, { useState } from "react";
import agent from "server";
import { getNotebookFileTypeFromUrl } from "components/utils";

interface INotebookRenderContext {
  getNotebookRenderHtml: (file: string) => Promise<string>;
}

export const NotebookRenderContext =
  React.createContext<INotebookRenderContext>({
    getNotebookRenderHtml: async () => "",
  });

interface Props {
  children: React.ReactNode;
}
const NotebookRenderContextProvider: React.FC<Props> = ({ children }) => {
  const [notebookRenderMap, setNotebookRenderMap] =
    useState<Record<string, string>>();

  const getNotebookRenderHtml = async (file: string): Promise<string> => {
    if (notebookRenderMap && notebookRenderMap[file]) {
      return notebookRenderMap[file];
    }

    const res = await agent.Notebooks.preview({
      sourceVal: {
        url: file,
        type: getNotebookFileTypeFromUrl(file),
      },
    });
    if (res && res.data) {
      setNotebookRenderMap((prev) => {
        return {
          ...prev,
          [file]: res.data,
        };
      });
      return res.data;
    } else {
      return "";
    }
  };

  const providerData = {
    getNotebookRenderHtml,
  };

  return (
    <NotebookRenderContext.Provider value={providerData}>
      {children}
    </NotebookRenderContext.Provider>
  );
};

export default NotebookRenderContextProvider;
